import { Storage } from "aws-amplify";

class FileUploadService {
	public static async getSignedUrl(
		key: string,
		expiresIn = 604800
	): Promise<string> {
		try {
			const url = await Storage.get(key, {
				level: "public",
				expires: expiresIn,
			});
			return typeof url === "string" ? url : String(url);
		} catch (error) {
			console.error("Get signed URL error:", error);
			throw new Error(
				`Failed to get signed URL: ${
					error instanceof Error ? error.message : "Unknown error"
				}`
			);
		}
	}
}

export default FileUploadService;
